export function CheckChangesMade(data: object, originalData: object) {
    let changesMade = false;

    const newData_ = JSON.stringify(data);
    const originalData_ = JSON.stringify(originalData);

    changesMade = originalData_ !== newData_;

    return changesMade;
}